import { Button } from "@thilke/ui/components/button";
import EnemyHealthDisplay from "@thilke/ui/components/enemy-health-display";
import HealthBar from "@thilke/ui/components/health-bar";
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemGroup,
  ItemMedia,
  ItemTitle,
} from "@thilke/ui/components/item";
import ManaBar from "@thilke/ui/components/mana-bar";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@thilke/ui/components/resizable";
import { ResourceBar } from "@thilke/ui/components/resource-bar";
import { Spinner } from "@thilke/ui/components/spinner";
import { toast } from "@thilke/ui/components/toast";
import XpBar from "@thilke/ui/components/xp-bar";

export function ResourceBarDemo() {
  return <ResourceBar value={68} className="h-4" variant="segmented" />;
}

export function EnemyHealthDisplayDemo() {
  return (
    <div className="w-full max-w-md">
      <EnemyHealthDisplay
        enemyName="Archive Warden"
        level={7}
        currentHealth={42}
        maxHealth={64}
      />
    </div>
  );
}

export function HealthBarDemo() {
  return <HealthBar value={72} className="h-4" variant="segmented" />;
}

export function ItemDemo() {
  return (
    <ItemGroup>
      <Item variant="outline">
        <ItemMedia>A</ItemMedia>
        <ItemContent>
          <ItemTitle>Archive pass</ItemTitle>
          <ItemDescription>
            Grants access to sealed registry records.
          </ItemDescription>
        </ItemContent>
      </Item>
    </ItemGroup>
  );
}

export function ManaBarDemo() {
  return <ManaBar value={54} className="h-4" variant="segmented" />;
}

export function ResizableDemo() {
  return (
    <div className="h-36 w-full max-w-lg rounded-md border">
      <ResizablePanelGroup direction="horizontal">
        <ResizablePanel defaultSize={55}>
          <div className="flex h-full items-center justify-center text-sm">
            Timeline
          </div>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel defaultSize={45}>
          <div className="flex h-full items-center justify-center text-sm">
            Inspector
          </div>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
}

export function SpinnerDemo() {
  return <Spinner className="size-8" />;
}

export function ToastDemo() {
  return (
    <Button variant="outline" onClick={() => toast("Registry updated")}>
      Show toast
    </Button>
  );
}

export function XpBarDemo() {
  return <XpBar value={86} className="h-4" variant="segmented" />;
}
